import React, { useEffect, useState } from 'react';
import { Button, Message, Checkbox } from "semantic-ui-react";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-markup"; // Import XML language for Prism
import "prismjs/themes/prism.css"; // Import a Prism theme (optional)

import edi from "../../store/service/cbp";

function Xml_Editor({records, shipmentId}) {
    const [xmlResponse, setXmlResponse] = useState("");
    const [xmlRequest, setXmlRequest] = useState("");
    const [useCBSAEnvironment, setUseCBSAEnvironment] = useState(false);
    const [loading, setLoading] = useState(false);
    const [messages, setMessages] = useState([]);
    const handleEditorChange = (value) => {
        setXmlResponse(value);
    };
    const handleRequestchange = (value) => {
        setXmlRequest(value);
    };

    useEffect(() => {
        if(records.length){
          if(records[0].xmlResponse){
            setXmlResponse(records[0].xmlResponse);
          }
          if(records[0].payload){
            setXmlRequest(records[0].payload);
          }
        }
        return(() => {
            setMessages([])
            setXmlResponse("");
            setXmlRequest("");
        })
    }, [])
    const saveXML = async ({event, diff}) => {
      try{
        setLoading(diff);
        let response = await edi.fileCarmRecords({shipmentid:shipmentId, xml:xmlRequest, event, useCBSAEnvironment})
        if(response?.data?.eventMessage?.fieldmessage){
            setMessages(response.data.eventMessage.fieldmessage || []);
        }
        else{
          setMessages([{field: "serverError",fieldmessage: "Something went wrong, please try again later"}]);
        }
        setLoading(0);
      }
      catch(error){
        setLoading(0);
        setMessages([{field: "serverError",fieldmessage: "Something went wrong, please try again later"}]);
      }
    };
    let successfulFileCondition = messages.length == 1 && messages[0].field=="CAD" && (messages[0].fieldmessage == "CAD request Filed Successfully" || messages[0].fieldmessage == "No Error")
    return (
        <div className='xml-editor' style={{ height: '500px', margin: '20px' }}>
            {
            successfulFileCondition ? 
                <Message positive>
                  <h4>Message:</h4>
                    {messages[0].fieldmessage}
                </Message>
            : !successfulFileCondition && messages[0]?.field === "serverError" ? 
                <Message negative>
                    {messages[0].fieldmessage}
                </Message>
            : messages.length > 0 &&
                <Message negative>
                <Message.Header>
                  Please fix below Validation errors:
                  <br />
                  <br />
                </Message.Header>
                {
                  messages.map(
                  (validationErrorMessage, index) => {
                    if (validationErrorMessage.fieldmessagetype === 'FAIL') {
                      return (
                        <p key={index}>
                          <div style={{ marginBottom: '5px' }}>
                            {validationErrorMessage.field} :{' '}
                            {validationErrorMessage.fieldmessage}{' '}
                            {validationErrorMessage.hasOwnProperty(
                              'lineItemDetail'
                            ) === true &&
                              validationErrorMessage.lineItemDetail.hasOwnProperty(
                                'invoiceNumber'
                              ) === true &&
                              validationErrorMessage.lineItemDetail.hasOwnProperty(
                                'lineNumber'
                              ) === true &&
                              'Invoice No' +
                                ' ' +
                                validationErrorMessage.lineItemDetail
                                  .invoiceNumber +
                                ' ' +
                                'Line No' +
                                ' ' +
                                validationErrorMessage.lineItemDetail
                                  .lineNumber +
                                ' '}
                            {validationErrorMessage.hasOwnProperty(
                              'invoiceId'
                            ) === true &&
                              validationErrorMessage.hasOwnProperty(
                                'merchandiseId'
                              ) === true &&
                              validationErrorMessage.hasOwnProperty(
                                'commodityCode'
                              ) === true &&
                              '('.concat(
                                validationErrorMessage.commodityCode
                              ) + ')'}
                            <span>
                              {validationErrorMessage.hasOwnProperty(
                                'merchandiseId'
                              ) === true && (
                                <Popup
                                  trigger={
                                    <Icon
                                      style={{
                                        cursor: 'pointer',
                                        color: 'blue',
                                      }}
                                      name='external alternate'
                                      onClick={() =>
                                        jumpToMerchandise(
                                          validationErrorMessage.merchandiseId
                                        )
                                      }
                                    />
                                  }
                                  content={'Jump To Merchandise '}
                                />
                              )}
                            </span>
                          </div>
                        </p>
                      )
                    }
                  }
                )}
              </Message>
            }
            <h2>XML Request:</h2>
              <div>
                <Checkbox checked={useCBSAEnvironment} className="xml-file-cbsa-checkbox" style={{position:"relative", top:"10px"}} onChange={()=>setUseCBSAEnvironment(!useCBSAEnvironment)} label="File CBSA UAT" />
                <Button className="xml-file-btn" loading={loading==1} style={{backgroundColor: "#308192", color:"white"}} size="mini" onClick={() => saveXML({event:"FILE_CAD_FROM_XML_UI", diff: 1})}>File</Button>
                <Button className= "xml-validate-btn" loading={loading==2} size="mini" style={{backgroundColor: "#308192", color:"white"}} onClick={()=>saveXML({event:"VALIDATE_REQUEST_CARM_XML", diff: 2})}>Validate</Button>
              </div>
            <div style={{height: "500px", overflow:"auto", marginBottom:"20px", paddingBottom: "10px", borderBottom: "1px solid #dfdfdf",  borderTop: "1px solid #dfdfdf", marginTop: "10px"}}>
              <Editor
                value={xmlRequest}
                onValueChange={handleRequestchange}
                highlight={(code) => highlight(code, languages.xml, "xml")}
                padding={10}
                tabSize={4}
                style={{
                  fontFamily: 'sans-serif',
                  fontSize: 14,
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  minHeight: "400px"
                }}
              />
            </div>
            <h2>XML Response:</h2>
            
            <div style={{height: "500px", overflow:"auto",marginBottom:"20px",  paddingBottom: "10px", borderBottom: "1px solid #dfdfdf", borderTop: "1px solid #dfdfdf"}}>
              <Editor
                value={xmlResponse}
                onValueChange={handleEditorChange}
                highlight={(code) => highlight(code, languages.xml, "xml")}
                padding={10}
                tabSize={4}
                style={{
                  fontFamily: 'sans-serif',
                  fontSize: 14,
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  minHeight: "400px"
                }}
                readOnly={true}
              />
            </div>
        </div>
    );
}

export default Xml_Editor;
